import { createAsyncThunk } from "@reduxjs/toolkit";
import { IObject } from "./stepSeven.types";
import { objectsKiiAPI } from "libs/apiClient/ObjectsKii";

export const getData = createAsyncThunk(
	"stepSevenSlice/getData",
	async (
		{
			organizationId,
			attachmentMode,
			part,
			count,
			setLoad,
		}: { organizationId: number; attachmentMode: boolean; part: number; count: number; setLoad?: () => void },
		{ rejectWithValue },
	) => {
		try {
			const response = await objectsKiiAPI
				.exportedListDetail(organizationId, { page: part, num: count, exportable: attachmentMode })
				.then((r) => r.data);
			// const response = (
			// 	await $api<IData>(
			// 		`/objects_kii/${organizationId}/exported/list?page=${part}&num=${count}&exportable=${attachmentMode}`,
			// 	)
			// ).data;
			if (setLoad) setLoad();
			return response;
		} catch ({ message }) {
			return rejectWithValue(message);
		}
	},
);

export const getSearchedData = createAsyncThunk(
	"stepSevenSlice/getSearchedData",
	async (
		{
			organizationId,
			searchValue,
			attachmentMode,
			part,
			count,
			setLoad,
		}: {
			organizationId: number;
			searchValue: string;
			attachmentMode: boolean;
			part: number;
			count: number;
			setLoad?: () => void;
		},
		{ rejectWithValue },
	) => {
		try {
			const response = await objectsKiiAPI
				.exportedListDetail(organizationId, {
					page: part,
					num: count,
					query: searchValue,
					exportable: attachmentMode,
				})
				.then((r) => r.data);
			// const response = (
			// 	await $api<IData>(
			// 		`/objects_kii/${organizationId}/exported/list?page=${part}&num=${count}&query=${searchValue}&exportable=${attachmentMode}`,
			// 	)
			// ).data;
			if (setLoad) setLoad();
			return response;
		} catch ({ message }) {
			return rejectWithValue(message);
		}
	},
);

export const uploadDocument = createAsyncThunk(
	"stepSevenSlice/uploadDocument",
	async (
		{
			organizationId,
			file,
			allCheckedGlobal,
			attachmentList,
			excludedObjects,
			filter,
			handler,
			callBack,
			reload,
		}: {
			organizationId: number;
			file: any;
			allCheckedGlobal: boolean;
			attachmentList: number[];
			excludedObjects: number[];
			filter?: boolean;
			handler?: boolean;
			callBack?: () => void;
			reload?: boolean;
		},
		{ rejectWithValue },
	) => {
		try {
			let response = await objectsKiiAPI
				.exportedLetterCreate(organizationId, {
					file,
					idlist: {
						all: allCheckedGlobal,
						include: allCheckedGlobal ? [] : attachmentList,
						exclude: allCheckedGlobal ? excludedObjects : [],
					},
				})
				.then((r) => r.data);

			if (callBack) callBack();

			let objectQuantity = 0;
			for (var key in response) {
				objectQuantity += response[key as keyof typeof response].length;
			}

			if (objectQuantity > 1 && reload) {
				response = await objectsKiiAPI
					.exportedListDetail(organizationId, { page: 1, num: 50, exportable: false })
					.then((r) => r.data);
			}
			return { response, objectQuantity, handler, filter, reload };
		} catch ({ message }) {
			return rejectWithValue(message);
		}
	},
);

export const updateDocument = createAsyncThunk(
	"stepSevenSlice/updateDocument",
	async (
		{ organizationId, file, attachmentList }: { organizationId: number; file: any; attachmentList: number[] },
		{ rejectWithValue },
	) => {
		try {
			// const params = new FormData();
			// params.append("file", file);
			// params.append(
			// 	"idlist",
			// 	JSON.stringify({
			// 		all: false,
			// 		include: attachmentList,
			// 		exclude: [],
			// 	}),
			// );
			return await objectsKiiAPI
				.exportedLetterCreate(organizationId, {
					file,
					idlist: {
						all: false,
						include: attachmentList,
						exclude: [],
					},
				})
				.then((r) => r.data);
			// return (await $api.post<any>(`/objects_kii/${organizationId}/exported/letter`, params)).data;
		} catch ({ message }) {
			return rejectWithValue(message);
		}
	},
);

export const dowloadDocument = createAsyncThunk(
	"stepSevenSlice/dowloadDocument",
	async (
		{ organizationId, name, documentKey }: { organizationId: number; name: string; documentKey: string },
		{ rejectWithValue },
	) => {
		try {
			return await objectsKiiAPI
				.exportedLetterDetail(
					organizationId,
					{
						key: documentKey,
						name,
					},
					{ format: "blob" },
				)
				.then((response) => {
					// create file link in browser's memory
					const href = URL.createObjectURL(response.data);

					// create "a" HTML element with href to file & click
					const link = document.createElement("a");
					link.href = href;
					link.setAttribute("download", `${name}`); //or any other extension
					document.body.appendChild(link);
					link.click();

					// clean up "a" element & remove ObjectURL
					document.body.removeChild(link);
					URL.revokeObjectURL(href);
				});
			// return $api({
			// 	url: `/objects_kii/${organizationId}/exported/letter?key=${documentKey}&name=${name}`, //your url
			// 	method: "GET",
			// 	responseType: "blob", // important
			// }).then((response) => {
			// 	// create file link in browser's memory
			// 	const href = URL.createObjectURL(response.data);
			//
			// 	// create "a" HTML element with href to file & click
			// 	const link = document.createElement("a");
			// 	link.href = href;
			// 	link.setAttribute("download", `${name}`); //or any other extension
			// 	document.body.appendChild(link);
			// 	link.click();
			//
			// 	// clean up "a" element & remove ObjectURL
			// 	document.body.removeChild(link);
			// 	URL.revokeObjectURL(href);
			// });
		} catch ({ message }) {
			return rejectWithValue(message);
		}
	},
);

export const assignNumber = createAsyncThunk(
	"stepSevenSlice/assignNumber",
	async (
		{
			organizationId,
			objectId,
			registrationNumber,
			selectedCategory,
			handler,
			updateRequired,
			file,
		}: {
			organizationId: number;
			objectId: number;
			registrationNumber: string;
			selectedCategory?: number | null;
			handler: boolean;
			updateRequired: boolean;
			file: any;
		},
		{ rejectWithValue },
	) => {
		try {
			let response = await objectsKiiAPI
				.exportedUpdate(organizationId, objectId, {
					registryId: registrationNumber,
					...(selectedCategory && { category: selectedCategory }),
				})
				.then((r) => r.data);
			// let response = (
			// 	await $api.put<any>(
			// 		`/objects_kii/${organizationId}/exported/${objectId}?registryId=${registrationNumber}${
			// 			selectedCategory ? `&category=${selectedCategory}` : ""
			// 		}`,
			// 	)
			// ).data;
			if (updateRequired) {
				// const params = new FormData();
				// params.append("file", file);
				// params.append(
				// 	"idlist",
				// 	JSON.stringify({
				// 		all: false,
				// 		include: [objectId],
				// 		exclude: [],
				// 	}),
				// );
				response = await objectsKiiAPI
					.exportedLetterCreate(organizationId, {
						file,
						idlist: {
							all: false,
							include: [objectId],
							exclude: [],
						},
					})
					.then((r) => r.data);
				// response = (await $api.post<any>(`/objects_kii/${organizationId}/exported/letter`, params)).data;
			}
			return { response, handler };
		} catch ({ message }) {
			return rejectWithValue(message);
		}
	},
);

export const assignAddressNumber = createAsyncThunk(
	"stepSevenSlice/assignAddressNumber",
	async (
		{
			orgId,
			object,
			addressId,
			registryId,
		}: {
			orgId: number;
			object: IObject;
			addressId: number;
			registryId: string;
		},
		{ rejectWithValue },
	) => {
		try {
			const response = await objectsKiiAPI
				.exportedLocationsUpdate(orgId, object.id, addressId, {
					registryId,
				})
				.then((r) => r.data);
			// const response = (
			// 	await $api.put<any>(
			// 		`/objects_kii/${orgId}/exported/${object.id}/locations/${addressId}?registryId=${registryId}`,
			// 	)
			// ).data;
			return { object, response };
		} catch ({ message }) {
			return rejectWithValue(message);
		}
	},
);

export const getObjectLocations = createAsyncThunk(
	"stepSevenSlice/getObjectLocations",
	async (
		{
			orgId,
			object,
		}: {
			orgId: number;
			object: IObject;
		},
		{ rejectWithValue },
	) => {
		try {
			const response = await objectsKiiAPI
				.exportedLocationsListDetail(orgId, object.id, { page: 1, num: 99999 })
				.then((r) => r.data);
			// const response = (await $api<any>(`/objects_kii/${orgId}/exported/${object.id}/locations/list?num=99999&page=1`))
			// 	.data;
			return { object, response };
		} catch ({ message }) {
			return rejectWithValue(message);
		}
	},
);

export const editInfo = createAsyncThunk(
	"stepSevenSlice/editInfo",
	async (
		{
			organizationId,
			objectId,
			registrationNumber,
			selectedCategory,
			handler,
		}: {
			organizationId: number;
			objectId: number;
			registrationNumber: string;
			selectedCategory?: number | null;
			handler: boolean;
		},
		{ rejectWithValue },
	) => {
		try {
			const response = await objectsKiiAPI
				.exportedUpdate(organizationId, objectId, {
					registryId: registrationNumber,
					...(selectedCategory && { category: selectedCategory }),
				})
				.then((r) => r.data);
			// const response = (
			// 	await $api.put<any>(
			// 		`/objects_kii/${organizationId}/exported/${objectId}?registryId=${registrationNumber}${
			// 			selectedCategory ? `&category=${selectedCategory}` : ""
			// 		}`,
			// 	)
			// ).data;
			return { response, handler };
		} catch ({ message }) {
			return rejectWithValue(message);
		}
	},
);

export const BGupdateDocument = createAsyncThunk(
	"stepSevenSlice/BGupdateDocument",
	async (
		{ organizationId, file, attachmentList }: { organizationId: number; file: any; attachmentList: number[] },
		{ rejectWithValue },
	) => {
		try {
			// const params = new FormData();
			// params.append("file", file);
			// params.append(
			// 	"idlist",
			// 	JSON.stringify({
			// 		all: false,
			// 		include: attachmentList,
			// 		exclude: [],
			// 	}),
			// );
			return await objectsKiiAPI
				.exportedLetterCreate(organizationId, {
					file,
					idlist: {
						all: false,
						include: attachmentList,
						exclude: [],
					},
				})
				.then((r) => r.data);
			// return (await $api.post<any>(`/objects_kii/${organizationId}/exported/letter`, params)).data;
		} catch ({ message }) {
			return rejectWithValue(message);
		}
	},
);
